import { render, staticRenderFns } from "./productPriceDialog.vue?vue&type=template&id=e65066fa&scoped=true"
import script from "./productPriceDialog.vue?vue&type=script&lang=js"
export * from "./productPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65066fa",
  null
  
)

export default component.exports